module.exports = __webpack_public_path__ + "app-static/img/03.92863254.jpg";